"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Introduction = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const Introduction = (param)=>{
    let { title, text } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.FORM_INTRODUCTION_FIELD),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "h3",
                component: "h3",
                textAlign: "center",
                color: "textPrimary",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                color: "textPrimary",
                children: (0, _utils.urlify)(text)
            })
        ]
    });
};
exports.Introduction = Introduction;
